import { useMutation } from '@tanstack/react-query';

import type { ConfirmResetPasswordRequest } from './PasswordManagementClient';
import { PasswordManagementClient } from './PasswordManagementClient';

type Props = {
  onSuccess: () => void;
  onError: () => void;
};

export const useConfirmResetPassword = ({ onSuccess, onError }: Props) => {
  const { mutate, isPending } = useMutation({
    mutationFn: (data: ConfirmResetPasswordRequest) =>
      PasswordManagementClient.confirmResetPassword(data),
    onSuccess,
    onError,
  });

  return {
    confirmResetPassword: mutate,
    isLoading: isPending,
  };
};
